export default __webpack_public_path__ + "static/media/locate.bf895621.svg";